import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/allForOrderReportRequestingFilter`;

export const ROUTE: RouteDefinition = `${baseRoute}/allForOrderReportRequestingFilter`;

export const URL = (): RouteDefinition => `${baseRoute}/allForOrderReportRequestingFilter`;
